/* eslint-disable no-console */

import CONFIG from '$config'

import {isSSR} from './common'

const notPrint = CONFIG.PROFILE === 'real' || (isSSR() && process.env.NODE_ENV === 'test')

// "debug"
// "error"
// "info"
// "log"
// "warn"
const prefix = '[myasset-web]:'
export default {
    info: (...args: unknown[]) => {
        if (notPrint) {
            return
        }

        console.info(prefix, ...args)
    },

    debug: (...args: unknown[]) => {
        if (notPrint) {
            return
        }

        console.debug(prefix, ...args)
    },

    warn: (...args: unknown[]) => {
        if (notPrint) {
            return
        }

        console.warn(prefix, ...args)
    },

    error: (...args: unknown[]) => {
        if (notPrint) {
            return
        }

        console.error(prefix, ...args)
    },

    log: (...args: unknown[]) => {
        if (notPrint) {
            return
        }
        console.log(prefix, ...args)
    },

    table: (...args: unknown[]) => {
        if (notPrint) {
            return
        }
        console.table(...args)
    },
}
